import React, {useCallback, useEffect, useState} from 'react';
import {
    Autocomplete,
    Box,
    Chip,
    CircularProgress,
    TextField,
    Typography,
} from '@mui/material';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

async function searchEeis(q) {
    const params = new URLSearchParams({q: q || '', size: '30'});
    const data = await fetch(`${BASE}/api/eeis?${params}`, {headers: authHeaders()})
        .then((r) => (r.ok ? r.json() : null));
    const items = Array.isArray(data?.items) ? data.items : (Array.isArray(data?.content) ? data.content : (Array.isArray(data) ? data : []));
    return items.map((e) => ({
        id: e.id,
        eeiNumber: e.eeiNumber || e.eei_number || '',
        text: e.text || '',
        priority: e.priority || 'Medium',
        icrId: e.icrId || e.icr_id || null,
    }));
}

/**
 * Multi-select linker for EEIs on a Collection Task.
 */
export default function IcrEeiLinker({
    eeis = [],
    onChange,
    disabled = false,
}) {
    const [eeiInput, setEeiInput] = useState('');
    const [eeiOptions, setEeiOptions] = useState([]);
    const [loadingEei, setLoadingEei] = useState(false);

    useEffect(() => {
        let cancelled = false;
        setLoadingEei(true);
        searchEeis(eeiInput)
            .then((opts) => { if (!cancelled) setEeiOptions(opts); })
            .finally(() => { if (!cancelled) setLoadingEei(false); });
        return () => { cancelled = true; };
    }, [eeiInput]);

    const handleEeis = useCallback((next) => {
        onChange?.({eeis: next});
    }, [onChange]);

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>Linked EEIs</Typography>
            <Autocomplete
                multiple
                disabled={disabled}
                options={eeiOptions}
                value={eeis}
                onChange={(_, v) => handleEeis(v)}
                inputValue={eeiInput}
                onInputChange={(_, v) => setEeiInput(v)}
                getOptionLabel={(o) => o.eeiNumber ? `${o.eeiNumber} — ${o.text}` : (o.text || o.id)}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                loading={loadingEei}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            {...getTagProps({index})}
                            key={option.id}
                            label={option.eeiNumber || option.text || option.id}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Search EEIs…"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loadingEei ? <CircularProgress color="inherit" size={16}/> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
        </Box>
    );
}
